import { Component, Input, OnInit } from '@angular/core';
import { UserInfoService } from '../services/user-info.service';
import { ZpDataService } from '../services/zp-data.service';
import { Subscription } from 'rxjs';
import { IUser } from '../models/user.model';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { FooterInfoService } from '../services/footer-info.service';
import { ThemeService } from '../theme/theme-service.service';



@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  @Input() public typeTerms;
  public loggedIn = false;
  public subscription: Subscription;
  public myUser: IUser;
  public menuType: string = "user";
  public now: number;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  
  constructor(private userInfo: UserInfoService,
    private ZpDataService: ZpDataService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService,
    private footerInfo: FooterInfoService) {
      setInterval(() => {
        this.now = new Date().getFullYear();
      }, 1);
     }

  ngOnInit() {
    var kk = this.menuType;
    this.subscription = this.userInfo.getMessage()
      .subscribe(user => {
        if (user && user != "null" && user.length > 0) {
          this.loggedIn = true;
        }
        else {
          this.loggedIn = false;
        }
        try {
          this.myUser = JSON.parse(user);
        }
        catch{ }
    });

    this.activeTheme = this.themeService.active;
    if (this.activeTheme.theme != 'default') {
      this.isDefaultTheme = false;
      console.log('isDefaultTheme: ', this.isDefaultTheme)
    }
  }
}
